<template>
  <div class="UsuariosDetalleCuenta">
    <div class="row">
      <div class="col-sm-12 col-md-4">
        <md-card class="m-b-24">
          <md-card-header>
            <div class="md-title">{{usuario.nombre_cue + ' ' + usuario.apellidos_cue}}</div>
          </md-card-header>
          <md-card-content>
            <strong>Email: </strong>{{usuario.email_cue}}<br>
            <strong>Fecha de nacimiento: </strong>{{usuario.fecha_nac_cue}}<br>
            <strong>Edad: </strong>{{usuario.edad_cue}} años<br>
            <strong>Sexo: </strong>{{unoMayus(usuario.sexo_cue)}}<br>
            <strong>Ciudad: </strong>{{unoMayus(usuario.ciudad_cue)}}<br>
            <strong>Estado: </strong>{{unoMayus(usuario.estado_cue)}}<br>
            <strong>Pais: </strong>{{usuario.nombre_pai}}<br>
            <strong>Ocupación: </strong>{{unoMayus(usuario.ocupacion_cue)}}<br>
            <strong>Institución: </strong>{{usuario.institucion_cue}}<br>
            <strong>Área de desempeño: </strong>{{unoMayus(usuario.area_desem_cue)}}<br>
            <strong>Vigencia de suscripción: </strong>{{moment(usuario.hasta_cus).format('LLLL')}}
          </md-card-content>
        </md-card>
      </div>
      <div class="col-sm-12 col-md-8">
        <md-table v-model="pagos" md-card>
          <md-table-toolbar>
            <h1 class="md-title">Pagos registrados</h1>
          </md-table-toolbar>
          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single" class="md-accent" @md-selected="verDetallePago">
            <md-table-cell md-label="Fecha" md-sort-by="fecha_ppp">{{item.fecha_ppp}}</md-table-cell>
            <md-table-cell md-label="Folio" md-sort-by="folio_ppp">{{item.folio_ppp}}</md-table-cell>
            <md-table-cell md-label="Correo de pago" md-sort-by="payer_info_email_ppp">{{item.payer_info_email_ppp}}</md-table-cell>
            <md-table-cell md-label="Importe" md-sort-by="amount_total_ppp">{{nF(item.amount_total_ppp) + ' '+item.amount_currency_ppp}}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
    <md-dialog :md-active.sync="modal_pago_single">
      <md-dialog-title>Información del pago</md-dialog-title>
      <md-dialog-content>
        <strong>FOLIO: </strong> {{pago.folio_ppp}}<br>
        <strong>Fecha del pago: </strong> {{pago.fecha_ppp}}<br>
        <strong>Correo usado en el pago: </strong> {{pago.payer_info_email_ppp}}<br>
        <strong>Nombre usado en el pago: </strong> {{pago.payer_info_first_name_ppp}} {{pago.payer_info_middle_name_ppp}} {{pago.payer_info_last_name_ppp}}<br>
        <strong>Estatus en PayPal: </strong> {{pago.state_ppp}}<br>
        <strong>Orden: </strong> {{pago.orderID_ppp}}<br>
        <strong>Núm. de pago: </strong> {{pago.paymentID_ppp}}<br>
        <strong>Total: </strong> {{nF(pago.amount_total_ppp)}} {{pago.amount_currency_ppp}}
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="modal_pago_single = false">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/es";

export default {
  name: "UsuariosDetalleCuenta",
  methods: {
    moment(a, b) {
      return moment(a, b);
    },
    nF(n) {
      return Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(n);
    },
    obtenerDetalleUsuario() {
      this.$http
        .post("usuarios/detalle", {
          token: this.$session.get("token"),
          c: this.$route.params.cuenta
        })
        .then(
          response => {
            if (response.status === 200 && "usuario" in response.body) {
              this.usuario = response.body.usuario;
              this.pagos = response.body.pagos;
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para obtener los tipos de pruebas";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    verDetallePago(p) {
      this.pago = p;
      this.modal_pago_single = true;
    },
    unoMayus(s) {
      if (s) {
        s = s.toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      usuario: {
        email_cue: null,
        nombre_cue: null,
        apellidos_cue: null,
        fecha_nac_cue: null,
        edad_cue: null,
        sexo_cue: null,
        ciudad_cue: null,
        estado_cue: null,
        nombre_pai: null,
        ocupacion_cue: null,
        institucion_cue: null,
        area_desem_cue: null,
        hasta_cus: null
      },
      pagos: [],
      pago: {
        id_ppp: null,
        folio_ppp: null,
        fecha_ppp: null,
        payer_info_email_ppp: null,
        payer_info_first_name_ppp: null,
        payer_info_middle_name_ppp: null,
        payer_info_last_name_ppp: null,
        state_ppp: null,
        orderID_ppp: null,
        paymentID_ppp: null,
        amount_total_ppp: null,
        amount_currency_ppp: null
      },
      modal_pago_single: false
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerDetalleUsuario();
  }
};
</script>